import { useMemo } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Tooltip } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";

const PatientMapRosterTableOpport = ({
  data = [],
  searchTerm = "",
  loading,
  total,
  page,
  pageSize,
  setPage,
  setPageSize,
  onSelectPatient
}) => {
  const rows = useMemo(() => {
    return data;
  }, [data, searchTerm]);

  const columns = useMemo(() => [
    { field: "MemberFullName", headerName: "Member Full Name", flex: 3, filterable: false },
    { field: "ServiceDate", headerName: "Service Date", flex: 1.5, filterable: false },
    { field: "ChartReviewDate", headerName: "Chart Review Date", flex: 2, filterable: false },
    { field: "AgingOfPreAdultReview", headerName: "Aging Of Pre-Adult Review", flex: 1, filterable: false },
    { field: "PreReviewedPCP", headerName: "Pre Reviewed PCP", flex: 2, filterable: false },
    { field: "PostAuditStatus", headerName: "Post Audit Status", flex: 2, filterable: false },
    {
      field: "AuditCharts",
      headerName: "Audit Charts",
      flex: 3,
      filterable: false,
      renderCell: (params) => {
        const count = params.row.AuditCharts?.length ?? 0;
        return `Audit Charts (${count})`;
      }
    },
    { field: "Staff", headerName: "Staff", flex: 2, filterable: false },
    
  ], [onSelectPatient]);

  return (
    <div style={{ width: "100%", overflowX: "auto" }}>
      <div style={{ minWidth: "1000px" }}>
        <DataGrid
          getRowId={(row) => `${row.MemberID}`}
          rows={rows}
          columns={columns}
          rowCount={total}
          paginationMode="server"
          paginationModel={{ page, pageSize }}
          onPaginationModelChange={({ page, pageSize }) => {
            setPage(page);
            setPageSize(pageSize);
          }}
          pageSizeOptions={[10, 25, 50, 100]}
          disableColumnFilter
          disableColumnSelector
          loading={loading}
          onRowClick={(params) => onSelectPatient(params.row)}
        />
      </div>
    </div>
  );
};

export default PatientMapRosterTableOpport;
